import loadable from '@loadable/component';
import React, { forwardRef } from 'react';

import RouteChunkErrorBoundary from '../../components/route/RouteChunkErrorBoundary';

/**
 * Shared route loadable factory: deferred import plus chunk-load failure recovery.
 * Assign stable webpackChunkName on the import; pass fallback via options.
 *
 * @param {Function|Object} loadFn
 * @param {Object} [options]
 * @returns {React.ComponentType}
 */
export default function createRouteLoadable(loadFn, options = {}) {
  const LoadableComponent = loadable(loadFn, options);

  const RouteLoadable = forwardRef(function RouteLoadable(props, ref) {
    return (
      <RouteChunkErrorBoundary>
        <LoadableComponent {...props} ref={ref} />
      </RouteChunkErrorBoundary>
    );
  });

  RouteLoadable.load = (...args) => LoadableComponent.load(...args);
  RouteLoadable.preload = (...args) => LoadableComponent.preload(...args);

  return RouteLoadable;
}
